module.exports = __webpack_public_path__ + "img/Getier.dc1222ef.jpg";